import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchProducts } from '../../store/actions/productActions';
import { firestore } from '../../config/firebase';
import Swal from 'sweetalert2';
import Spinner from '../UIComponents/Spinner';
import lang from './lang';
import './Payments.css';


class Payments extends Component {
    state = { data: [], display: 'none' }

    componentDidMount() {
        let sortData = {};
        this.props.products.map(item => {

            const { piece, totalSize, quality = "unknown", factoryPrice, merchantPrice, roll, category } = item;
            if (sortData[quality]) {
                const { pieces, totalSize: totalProductSize } = sortData[quality];
                return sortData[quality] = {
                    factoryPrice,
                    merchantPrice,
                    name: quality,
                    pieces: category === 'carpet' ? (pieces + piece) : (pieces + roll),
                    totalSize: totalProductSize + parseFloat(totalSize),
                }

            } else {
                return sortData[quality] = {
                    name: quality,
                    pieces: category === 'carpet' ? piece : roll,
                    totalSize: parseFloat(totalSize),
                    factoryPrice,
                    merchantPrice,
                }

            }
        });

        const data = Object.values(sortData).sort((a, b) => {
            if (a.name > b.name) {
                return 1
            } else if (a.name < b.name) {
                return -1
            } else {
                return 0
            }
        });

        return this.setState({ data });

    }


    inputHandler = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    qualityHandler = (quality) => {
        this.setState({ display: 'flex' })
        const factoryPrice = this[`${quality}factoryPrice`].value;
        const merchantPrice = this[`${quality}merchantPrice`].value;

        const batch = firestore.batch();
        firestore
            .doc(`users/${this.props.user.id}`)
            .collection('products')
            .where('quality', '==', quality)
            .get()
            .then(data => {
                data.docs.forEach(doc => {
                    batch.update(doc.ref, {
                        factoryPrice: factoryPrice.includes('.') ? parseFloat(factoryPrice) : parseInt(factoryPrice),
                        totalFactoryPrice: factoryPrice.includes('.') ? parseFloat(factoryPrice * doc.data().totalSize) : parseInt(factoryPrice * doc.data().totalSize),
                        merchantPrice: merchantPrice.includes('.') ? parseFloat(merchantPrice) : parseInt(merchantPrice),
                        totalMerchantPrice: merchantPrice.includes('.') ? parseFloat(merchantPrice * doc.data().totalSize) : parseInt(merchantPrice * doc.data().totalSize),
                        success: true
                    });
                });

                return batch.commit().then(() => {
                    this.setState({ display: 'none' })
                    Swal.fire({
                        type: 'success',
                        title: 'Success',
                        text: 'Payment has been updated successfully',
                        showCloseButton: true
                    });

                    firestore
                        .doc(`users/${this.props.user.id}`)
                        .collection('products')
                        .get()
                        .then(doc => {
                            const data = doc.docs.map(item => ({ id: item.id, ...item.data() }));
                            this.props.fetchProducts(data);
                        })
                })
            })

    }

    componentDidUpdate(prevProps) {
        if (prevProps.products !== this.props.products) {
            let sortData = {};
            this.props.products.map(item => {

                const { piece, totalSize, quality = "unknown", factoryPrice, merchantPrice } = item;
                if (sortData[quality]) {
                    const { pieces, totalSize: totalProductSize } = sortData[quality];
                    sortData[quality] = {
                        factoryPrice,
                        merchantPrice,
                        name: quality,
                        pieces: parseInt(pieces + piece),
                        totalSize: parseInt(totalProductSize) + parseInt(totalSize),
                    }

                } else {
                    sortData[quality] = {
                        name: quality,
                        pieces: piece,
                        totalSize: parseInt(totalSize),
                        factoryPrice,
                        merchantPrice,
                    }

                }

                return sortData[quality];
            });

            const data = Object.values(sortData).sort((a, b) => {
                if (a.name > b.name) {
                    return 1
                } else if (a.name < b.name) {
                    return -1
                } else {
                    return 0
                }
            });
            this.setState({ data });
        }

    }


    render() {
        // Translations
        const {
            quality,
            quantity,
            square,
            importPrice,
            salePrice,
            more,
            save
        } = lang[this.props.user.lang || 'en'];

        const totalIncome = this.state.data.reduce((total, item) => {
            console.log(item)
            total.sale += (item.totalSize * item.merchantPrice);
            total.base += item.totalSize * item.factoryPrice;
            total.size += parseInt(item.totalSize);
            total.pieces += parseInt(item.pieces)
            return total
        }, { size: 0, sale: 0, base: 0, pieces: 0 });


        const factoryIncome = this.props.user.currency === 'UZS' ? parseInt((totalIncome.base) * this.props.user.uzsAmount).toLocaleString() : parseInt(totalIncome.base).toLocaleString()
        const merchantIncome = this.props.user.currency === 'UZS' ? parseInt((totalIncome.sale) * this.props.user.uzsAmount).toLocaleString() : parseInt(totalIncome.sale).toLocaleString()
        return (
            <div id="products-price-page">
                <Spinner display={this.state.display} />
                <div className="card-body d-flex">
                    <table className="table table-striped table-sm table-responsive-md">
                        <thead className="thead-dark">
                            <tr>
                                <th> # </th>
                                <th>{quality}</th>
                                <th>{quantity}</th>
                                <th>{square} <span className="text-success"> m<sup>2</sup></span> </th>
                                <th>{importPrice}</th>
                                <th>{square}</th>
                                <th>{salePrice}</th>
                                <th>{square}</th>
                                <th>{more}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                this.state.data.map((item, index) => {
                                    const factoryprice = this.props.user.currency === 'UZS' ? parseInt((item.totalSize * item.factoryPrice) * this.props.user.uzsAmount).toLocaleString() : parseInt(item.totalSize * item.factoryPrice).toLocaleString()
                                    const merchantprice = this.props.user.currency === 'UZS' ? parseInt((item.totalSize * item.merchantPrice) * this.props.user.uzsAmount).toLocaleString() : parseInt(item.totalSize * item.merchantPrice).toLocaleString()
                                    return (
                                        <tr key={item.name}>
                                            <td>{index + 1}</td>
                                            <td className="text-capitalize">{item.name}</td>
                                            <td>{item.pieces}</td>
                                            <td>{parseFloat(item.totalSize).toFixed(2)} <span className="text-success"> m<sup>2</sup></span></td>
                                            <td><input type="number" className="form-control" size="15" ref={ref => this[item.name + 'factoryPrice'] = ref} name="factoryPrice" defaultValue={item.factoryPrice} /></td>
                                            <td>{factoryprice}</td>
                                            <td><input type="number" className="form-control" size="15" ref={ref => this[item.name + 'merchantPrice'] = ref} name="merchantPrice" defaultValue={item.merchantPrice} /></td>
                                            <td>{merchantprice}</td>
                                            <td>
                                                <button
                                                    className="btn btn-outline-success btn-sm"
                                                    onClick={quality => this.qualityHandler(item.name)}
                                                >{save}</button>
                                            </td>
                                        </tr>
                                    )
                                })
                            }
                            <tr>
                                <td></td>
                                <th>{square}</th>
                                <th>{totalIncome.pieces}</th>
                                <td>{parseFloat(totalIncome.size).toFixed(2)} <span className="text-success"> m<sup>2</sup></span></td>
                                <td></td>
                                <td><small className="text-success">{this.props.user.currency}</small> {factoryIncome}</td>
                                <td></td>
                                <td colSpan="2"><small className="text-success">{this.props.user.currency}</small> {merchantIncome}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        user: state.user,
        products: state.products.products
    }
}

const mapDispatchToProps = dispatch => {
    return {
        fetchProducts: (data) => dispatch(fetchProducts(data))
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(Payments);